// Ключ периода платежа — один на группировку и на строки отчёта.
//
// Раньше он считался тремя разными способами: группировка в месячном виде
// сдвигала дату на −3 часа, в годовом брала год из строки, а сама строка
// таблицы считала год по локальному времени. Когда способы расходились, строка
// показывала 0 во всех колонках периодов, а её сумма оставалась в «Итого» —
// поэтому отчёт не сходился с выгрузкой в Excel.
//
// «Дата документа» — календарная дата, а не момент времени, поэтому разбираем
// её как текст: никакие часовые пояса на принадлежность к месяцу и году не
// влияют.

export const NO_DATE_KEY = "Без даты";

export function periodKeyOf(dateDoc, view) {
  if (dateDoc === null || dateDoc === undefined || dateDoc === "") return NO_DATE_KEY;

  const [datePart] = String(dateDoc).split("T");
  const [year, month] = datePart.split("-");
  if (!year || !/^\d{4}$/.test(year)) return NO_DATE_KEY;

  if (view === "month") {
    if (!month || !/^\d{1,2}$/.test(month)) return NO_DATE_KEY;
    return `${year}-${String(month).padStart(2, "0")}`;
  }
  return year;
}

// «Без даты» всегда последним: это не период, а отсутствие даты.
export function sortPeriodKeys(keys) {
  return [...keys].sort((a, b) => {
    if (a === NO_DATE_KEY) return b === NO_DATE_KEY ? 0 : 1;
    if (b === NO_DATE_KEY) return -1;

    const [aYear, aMonth = "0"] = a.split("_")[0].split("-");
    const [bYear, bMonth = "0"] = b.split("_")[0].split("-");
    return Number(aYear) !== Number(bYear)
      ? Number(aYear) - Number(bYear)
      : Number(aMonth) - Number(bMonth);
  });
}
